import * as zod from "zod";

const CampaignFilterConditionSchema_ = zod.object({
  field: zod.string(),
  operator: zod.string(),
  value: zod.union([
    zod.string(),
    zod.array(zod.string()),
    zod.number(),
    zod.boolean(),
  ]),
});

export const CampaignFilterConditionSchema: zod.ZodType<CampaignFilterCondition> =
  CampaignFilterConditionSchema_;
export interface CampaignFilterCondition extends zod.infer<
  typeof CampaignFilterConditionSchema_
> {}

const CampaignScheduleSchema_ = zod.object({
  type: zod.enum(["immediate", "scheduled"]),
  daysOfWeek: zod.array(zod.number()).optional(),
  timeUtc: zod.string().optional(),
  timezone: zod.string().optional(),
  recurring: zod.boolean(),
});

export const CampaignScheduleSchema: zod.ZodType<CampaignSchedule> =
  CampaignScheduleSchema_;
export interface CampaignSchedule extends zod.infer<
  typeof CampaignScheduleSchema_
> {}

const CampaignSlackDestinationSchema_ = zod.object({
  type: zod.enum(["channel", "dm"]),
  channelId: zod.string(),
  channelName: zod.string().optional(),
});

export const CampaignSlackDestinationSchema: zod.ZodType<CampaignSlackDestination> =
  CampaignSlackDestinationSchema_;
export interface CampaignSlackDestination extends zod.infer<
  typeof CampaignSlackDestinationSchema_
> {}

const CampaignSchema_ = zod.object({
  _id: zod.string(),
  name: zod.string(),
  description: zod.string().optional(),
  filters: zod.array(CampaignFilterConditionSchema),
  filterLogic: zod.enum(["and", "or"]),
  schedule: CampaignScheduleSchema,
  messageStyle: zod.enum(["individual", "digest"]),
  destination: CampaignSlackDestinationSchema,
  isActive: zod.boolean(),
  createdBy: zod.string(),
  createdAt: zod.string(),
  updatedAt: zod.string(),
  lastExecutedAt: zod.string().optional(),
  messageCount: zod.number(),
});

export const CampaignSchema: zod.ZodType<Campaign> = CampaignSchema_;
export interface Campaign extends zod.infer<typeof CampaignSchema_> {}

export const getCampaigns = {
  name: "getCampaigns" as const,
  input: zod.object({}),
  output: zod.object({ campaigns: zod.array(CampaignSchema) }),
};
